import { useContext } from "react";
import { MessagingContext } from "./MessagesProvider";

export const useMessages = () => useContext(MessagingContext);
